<template>
  <component
    :is="as"
    v-bind="$attrs"
    :class="['heading', as, 'text-line-normal']"
  >
    <slot />
  </component>
</template>

<script setup>
defineOptions({ name: "C_Heading", inheritAttrs: false });

defineProps({
  as: { type: String, default: "h1" },
});

import { useRouter } from "vue-router";

const router = useRouter();
</script>

<style lang="scss" scoped>
.heading {
  margin: 0;
  font-weight: normal;
  opacity: 0.75;
}
.h1 {
  font-size: 1.5rem;
}
.h2 {
  font-size: 1.3rem;
}
.h3 {
  font-size: 1.15rem;
}
.h4,
.h5,
.h6 {
  font-size: 1rem;
}
.h4 {
}
.h5 {
}
.h6 {
}
</style>
